export default __webpack_public_path__ + "static/media/thumbnail-default.36c79470.jpg";